import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/atlas.css';

// ── Production hardening ──────────────────────────────────────────────────────

if (process.env.NODE_ENV === 'production') {
  // Suppress console output so implementation details don't leak to end-users.
  // console.error and console.warn are kept for error monitoring tools (Sentry etc.).
  console.log   = () => {};
  console.info  = () => {};
  console.debug = () => {};

  // Report Content Security Policy violations to the error stream so they
  // surface in any monitoring pipeline that captures console.error.
  document.addEventListener('securitypolicyviolation', (e) => {
    console.error('[CSP]', e.violatedDirective, '—', e.blockedURI);
  });
}

// ── App bootstrap ─────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
